import React from 'react';
import CommunityFund from './CommunityFund';
function App() {
  return <CommunityFund />;
}
export default App;
